export function drawGridBase(grid, map, ctx, fill=true, showGridName, zoom, strokeStyle){
  var w=0.01/2 
  var j=0.01/2

  let lng = grid.lng
  let lat = grid.lat
  let arr = [0, 0, 0, 0, grid.id]
  var lat1=lat+j
  var lat2=lat-j
  var lng1=lng+w
  var lng2=lng-w
  arr[0] = lng1
  arr[2] = lat1
  arr[1] = lng2
  arr[3] = lat2
  var p1=new BMap.Point(lng1,lat2)
  var p2=new BMap.Point(lng1,lat1)
  var p3=new BMap.Point(lng2,lat1)
  var p4=new BMap.Point(lng2,lat2)
  var p5=new BMap.Point(lng,lat)
  var pixel1=map.pointToPixel(p1)
  var pixel2=map.pointToPixel(p2)
  var pixel3=map.pointToPixel(p3)
  var pixel4=map.pointToPixel(p4)
  var center=map.pointToPixel(p5)
  let lineWidth = 2
  // if (grid.name == chooseGrid.name){
  //   lineWidth = 8
  // }
  
  if (strokeStyle) {
    ctx.strokeStyle = strokeStyle
  }else {
    if (grid.hot_point){
      ctx.strokeStyle="red";  
      ctx.lineWidth=lineWidth;  
    }else{
      ctx.strokeStyle="#5f728447";  
      ctx.lineWidth=lineWidth;  
    }
  }
  ctx.beginPath()
  ctx.moveTo(pixel1.x,pixel1.y)
  ctx.lineTo(pixel2.x,pixel2.y)
  ctx.lineTo(pixel3.x,pixel3.y)
  ctx.lineTo(pixel4.x,pixel4.y)
  ctx.closePath()
  ctx.stroke()
  let font_size = (pixel1.y - pixel2.y)/5 + 'px Arial'
  
  
  if (fill == true){
    var bgcolor = '#ff0000'
    var fgcolor = 'black'
    var grid_border = '#5f728447'
    if (zoom >= 12 &&showGridName && grid.hot_point && (grid.name || grid.name == 0)){
      ctx.fillStyle=fgcolor
      ctx.textAlign = 'center'
      ctx.zIndex = 10
      ctx.font=font_size
      ctx.fillText(grid.name, center.x,center.y)
    }
  }
  
  ctx.beginPath()
  ctx.moveTo(pixel1.x,pixel1.y)
  ctx.lineTo(pixel2.x,pixel2.y)
  ctx.lineTo(pixel3.x,pixel3.y)
  ctx.lineTo(pixel4.x,pixel4.y)
  ctx.closePath()
  ctx.stroke()
  return arr
}


// WEBPACK FOOTER //
// ./src/components/edf/draw.js